import React from "react";
import dayjs from "dayjs";

import ChartContainer from "../../shared/ChartContainer";

const getAvg = (row = {}) => {
  if (typeof row["avg->unit_price"] === "number") return row["avg->unit_price"];
  if (typeof row?.avg?.unit_price === "number") return row.avg.unit_price;
  if (typeof row?.avg_unit_price === "number") return row.avg_unit_price;
  if (typeof row?.unit_price === "number") return row.unit_price;
  return Number(row["avg->unit_price"] || row?.avg?.unit_price || 0);
};

const getCount = (row = {}) => {
  if (typeof row.count === "number") return row.count;
  if (typeof row["count"] === "number") return row["count"];
  return Number(row?.count || 0);
};

const getBucketDate = (row = {}, granularity) => {
  const y = row?.record_at_year || row?.year || row["year(record_at)"];
  const m = row?.record_at_month || row?.month || row["month(record_at)"];
  const d = row?.record_at_day || row?.day || row["day(record_at)"] || 1;

  if (!y || !m) return null;
  return dayjs(`${y}-${m}-${granularity === "day" ? d : 1}`);
};

const toChart = (rows = [], granularity = "month") => {
  const bucket = {};

  rows.forEach((row) => {
    const date = getBucketDate(row, granularity);
    if (!date || !date.isValid()) return;

    const key = date.format(granularity === "day" ? "YYYY-MM-DD" : "YYYY-MM");
    const avg = getAvg(row);
    const count = getCount(row);

    if (!bucket[key]) {
      bucket[key] = {
        weight: 0,
        sum: 0,
        date,
      };
    }

    bucket[key].sum += avg * (count || 1);
    bucket[key].weight += count || 1;
  });

  const ordered = Object.values(bucket).sort((a, b) => a.date.valueOf() - b.date.valueOf());
  const labels = ordered.map((x) =>
    x.date.format(granularity === "day" ? "MMM D" : "MMM YYYY")
  );
  const data = ordered.map((x) => Number((x.sum / x.weight).toFixed(2)));

  return { labels, data };
};

const PriceTrendChart = ({ reportLabel, rows = [], granularity = "month" }) => {
  const chart = toChart(rows, granularity);
  return (
    <ChartContainer
      title={`${reportLabel} price history`}
      description="Average unit price (CAD/kg) over time."
      labels={chart.labels}
      datasets={[
        {
          label: "Avg unit price",
          data: chart.data,
          backgroundColor: "#2457A5",
        },
      ]}
    />
  );
};

export default PriceTrendChart;
